import { render, staticRenderFns } from "./AdquirirPacotes.vue?vue&type=template&id=8b847e08&"
import script from "./AdquirirPacotes.vue?vue&type=script&lang=js&"
export * from "./AdquirirPacotes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports